export default "__VITE_ASSET__db5d8852__"